module.exports = {
      id: "triangle-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#triangle-usage",
      toString: function () {
        return this.url;
      }
    }